/**
 * Keep original order in keyvalue pipe.
 * Usage: *ngFor="let item of items | keyvalue: originalOrder"
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function originalOrderFn(): number {
  return 0;
}
